import { createContext, useContext } from "react";
import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * Kontext „jsem ve sbaleném sidebaru" — Sidebar ho nastaví jednou nahoře,
 * SidebarNavLink/SidebarSection si ho přečtou (bez prop-drillingu přes ~35
 * odkazů). Mobilní sheet nastavuje false — tam je sidebar vždy plný.
 */
export const SidebarCollapsedContext = createContext(false);

export function useSidebarCollapsed(): boolean {
  return useContext(SidebarCollapsedContext);
}

interface SidebarStore {
  /** Sbalený režim — jen ikony (68px). Platí pro desktop; mobil má sheet vždy plný. */
  collapsed: boolean;
  toggle: () => void;
  /** Sbalené sekce podle labelu. Chybějící klíč = sekce rozbalená. */
  collapsedSections: Record<string, boolean>;
  toggleSection: (label: string) => void;
}

/** Persistovaná volba sbalení sidebaru (přežije reload i odhlášení). */
export const useSidebarStore = create<SidebarStore>()(
  persist(
    (set) => ({
      collapsed: false,
      toggle: () => set((s) => ({ collapsed: !s.collapsed })),
      collapsedSections: {},
      toggleSection: (label) =>
        set((s) => ({
          collapsedSections: {
            ...s.collapsedSections,
            // Default sekcí je SBALENO — musí sedět se sidebar-section.tsx.
            [label]: !(s.collapsedSections[label] ?? true),
          },
        })),
    }),
    { name: "hca-sidebar" },
  ),
);
